import { lazy } from 'react'
import Route from './route'

// Layouts base
import { BaseLayout } from '../layouts'
import { GameProvider, PageProvider } from '../../contexts'
import Home from '../../../main/factories/pages/home/home'
import Mission from '../../pages/mission'

const Signin = lazy(() => import('../../pages/amplify/signin'))
const Signup = lazy(() => import('../../pages/amplify/signup'))
const SignupLink = lazy(() => import('../../pages/amplify/signup-link'))
const ActivateAccount = lazy(() => import('../../pages/amplify/activate-account'))
const Logout = lazy(() => import('../../pages/amplify/logout'))
const Clear = lazy(() => import('../../pages/clear'))
const ForgotPassword = lazy(() => import('../../pages/amplify/forgot-password'))
const RecoveryPassword = lazy(() => import('../../pages/amplify/recovery-password'))
const Greetings = lazy(() => import('../../pages/greetings'))
const Instructions = lazy(() => import('../../pages/instructions'))
const ApprovalInstructions = lazy(() => import('../../pages/approval-instructions'))
const PageNotFound = lazy(() => import('../../pages/errors/page_not_found'))
const GameNotFound = lazy(() => import('../../pages/errors/game_not_found'))
const NoAuthorization = lazy(() => import('../../pages/errors/no_authorization'))
const HomeLobby = lazy(() => import('../../pages/amplify/home-lobby'))
const DisableNotification = lazy(() => import('../../pages/notification/disable'))
const ClickedNotification = lazy(() => import('../../pages/notification/clicked'))
// Academy
const Game = lazy(() => import('../../../main/factories/pages/game/game'))

const Routes = () => {
  const routes = [
    {
      layout: BaseLayout,
      data: [
        { path: '/', component: Home },
        { path: '/clear', component: Clear },
        { path: '/greetings', component: Greetings },
        { path: '/instructions', component: Instructions },
        { path: '/approval-instructions', component: ApprovalInstructions },
        { path: '/mission', component: Mission },
        { path: '/login', component: Signin },
        { path: '/signup', component: Signup },
        { path: '/signup/team/:token', component: SignupLink },
        { path: '/signup/game/:token', component: SignupLink },
        { path: '/activate-account/:token', component: ActivateAccount },
        { path: '/esqueci-minha-senha', component: ForgotPassword },
        { path: '/recuperar-senha', component: RecoveryPassword },
        { path: '/sair', component: Logout },
        { path: '/403', component: NoAuthorization },
        { path: '/404', component: PageNotFound },
        { path: '/game-not-found', component: GameNotFound },
        { path: '/game/:slug', component: Game },
        { path: '/:slug', component: Home },
        { path: '/home-lobby', component: HomeLobby },
        { path: '/disable-notification/:hash', component: DisableNotification },
        { path: '/clicked-notification/:hash', component: ClickedNotification },
        { path: '*', component: PageNotFound }
      ]
    }
  ]

  return (
    <PageProvider>
      <GameProvider>
        <Route data={routes} />
      </GameProvider>
    </PageProvider>
  )
}

export default Routes
